"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const react_router_dom_1 = require("react-router-dom");
const selectors_1 = require("~/store/selectors");
const UI_1 = require("~/components/UI");
const actions_1 = require("~/store/project/actions");
const events_1 = require("~/utils/events");
const routes_1 = require("~/consts/routes");
const actions_2 = require("~/store/actions");
const DuplicateProjectModal_module_scss_1 = __importDefault(require("./DuplicateProjectModal.module.scss"));
function DuplicateProjectModal({ project, duplicatedFromToolbox, onDuplicate = () => {
    // do nothing
}, }) {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)('project');
    const duplicatedProject = (0, react_redux_1.useSelector)(selectors_1.selectDuplicatedProject);
    const isDuplicating = (0, react_redux_1.useSelector)(selectors_1.selectProjectDuplicatingState);
    const [projectName, setProjectName] = (0, react_1.useState)(`Copy of ${(_a = project === null || project === void 0 ? void 0 : project.name) !== null && _a !== void 0 ? _a : ''}`);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [duplicatingProject, setDuplicatingProject] = (0, react_1.useState)(false);
    const { dispatchDuplicateProject, dispatchDuplicateProjectSuccess, dispatchValidateTokenAction } = (0, redux_1.bindActionCreators)({
        dispatchDuplicateProject: actions_1.duplicateProject,
        dispatchDuplicateProjectSuccess: actions_1.duplicateProjectSuccess,
        dispatchValidateTokenAction: actions_2.validateTokenAction,
    }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        if (duplicatedProject) {
            dispatchDuplicateProjectSuccess(null);
            if (duplicatedFromToolbox) {
                (0, events_1.hideModal)();
                navigate(`/projects/${duplicatedProject.id}`);
            }
            else {
                (0, events_1.hideModal)();
                onDuplicate();
            }
        }
    }, [duplicatedProject]);
    (0, react_1.useEffect)(() => {
        setDuplicatingProject(isDuplicating);
    }, [isDuplicating]);
    const handleDuplicateProject = () => {
        dispatchValidateTokenAction(() => {
            (0, events_1.hideModal)();
            return navigate(routes_1.ROUTE_LOGIN);
        });
        dispatchDuplicateProject({
            name: projectName,
            id: project.id,
            isDuplicatedProjectOpening: !!duplicatedFromToolbox,
        });
    };
    return (react_1.default.createElement("div", { className: DuplicateProjectModal_module_scss_1.default.modal },
        react_1.default.createElement("div", { className: DuplicateProjectModal_module_scss_1.default.title }, t('duplicate-project-modal.title')),
        react_1.default.createElement("div", { className: DuplicateProjectModal_module_scss_1.default.section },
            react_1.default.createElement("div", { className: DuplicateProjectModal_module_scss_1.default.subtitle }, t('duplicate-project-modal.project-name-subtitle')),
            react_1.default.createElement(UI_1.Input, { placeholder: t('duplicate-project-modal.project-name-placeholder'), value: projectName, type: "text", onInput: (value) => {
                    setProjectName(value);
                }, disabled: duplicatingProject, maxLength: 60, required: true, customErrors: { required: t('duplicate-project-modal.project-name-required-error') } })),
        react_1.default.createElement("div", { className: DuplicateProjectModal_module_scss_1.default.footer },
            react_1.default.createElement(UI_1.Button, { onClick: events_1.hideModal, disabled: duplicatingProject }, t('duplicate-project-modal.cancel-button')),
            react_1.default.createElement(UI_1.Button, { variant: "primary", disabled: !projectName || duplicatingProject, onClick: handleDuplicateProject },
                react_1.default.createElement("div", { className: duplicatingProject ? DuplicateProjectModal_module_scss_1.default.loader : '' },
                    duplicatingProject ? react_1.default.createElement(UI_1.SpinnerLoader, null) : '',
                    " ",
                    t('duplicate-project-modal.duplicate-button'))))));
}
DuplicateProjectModal.defaultProps = {
    duplicatedFromToolbox: false,
    onDuplicate: () => {
        // do nothing
    },
};
exports.default = DuplicateProjectModal;
